import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Image, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Autocomplete } from "@react-google-maps/api";
import axios from "axios";

// Import services
import uploadFiles from "../service/uploadFileService";

// Import assets
import project1 from "../assets/img/project1.jpg";
import project2 from "../assets/img/project2.jpg";
import project3 from "../assets/img/repidstace-other.jpg";
import BathroomIcon from "../assets/img/BathroomIcon.svg";
import kitchenIcon from "../assets/img/kitchenIcon.svg";
import otherIcon from "../assets/img/otherIcon.svg";
import idcard from "../assets/img/id-card.png";
import emailicon from "../assets/img/email_icon.png";
import mapIcon from "../assets/img/mapIcon.png";
import callIcon from "../assets/img/callIcon.png";
import Description from "../assets/img/description.png";

// Import components
import BathroomModal from "../components/BathroomModal";
import ConfirmationModal from "./ConfirmationModal";
import PhotoUploadModal from "./PhotoUploadModal";
import ThankyouModal from "./ThankyouModal";
import OtherModal from "./OtherModal";
import KitchenModal from "./KitchenModal";
import ConfirmationModal2 from "./ConfirmationModal2";
import PhotoUploadModal2 from "./PhotoUploadModal2";
import LetsConnect from "./LetsConnectModal";
import PhotoUploadModal3 from "./PhotoUploadModal3";
import PhotoLightboxHost from "./PhotoLightbox";
import {
  GOOGLE_PLACES_AUTOCOMPLETE_OPTIONS,
  googlePlaceIsUnitedStates,
} from "../constants/company";
import { cleanupModalScrollLock } from "../utils/modalScrollCleanup";
import "./rapidEstimateModals.scss";

const API_URL = process.env.REACT_APP_API_URL;

const uploadFilesBySlots = async (slots) => {
  const filesToUpload = slots.filter(Boolean);
  const uploadedUrls = filesToUpload.length ? await uploadFiles(filesToUpload) : [];

  let uploadIndex = 0;
  return slots.map((slot) => {
    if (!slot) return "";
    return uploadedUrls[uploadIndex++];
  });
};

const appendOtherImages = (formData, urls) => {
  urls.filter(Boolean).forEach((url) => formData.append("otherImgs", url));
};

// Project types data
const PROJECT_TYPES = [
  {
    id: "bathroom",
    img: project1,
    name: "Bathroom",
    icon: BathroomIcon,
  },
  {
    id: "kitchen",
    img: project2,
    name: "Kitchen",
    icon: kitchenIcon,
  },
  {
    id: "others",
    img: project3,
    name: "Other",
    icon: otherIcon,
  },
];

const GetStarted = ({ show, handleClose, showModal, setCloseShowModal, showType }) => {
  // Modal states
  const [bathroom, setBathroom] = useState(false);
  const [kitchen, setKitchen] = useState(false);
  const [other, setOther] = useState(false);
  const [personalInfo, setPersonalInfo] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmation2, setConfirmation2] = useState(false);
  const [photoUpload, setPhotoUpload] = useState(false);
  const [photoUpload2, setPhotoUpload2] = useState(false);
  const [photoUpload3, setPhotoUpload3] = useState(false);
  const [thankyou, setThankyou] = useState(false);

  // Form states
  const [step, setStep] = useState(1);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [validated, setValidated] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageKitchen, setErrorMessageKitchen] = useState("");

  // Form data states
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [contact, setContact] = useState("");
  const [description, setDescription] = useState("");
  const [formDataResponse, setFormDataResponse] = useState("");
  const [formDataImg, setFormDataImg] = useState();

  // Refs
  const stepOneFormRef = useRef(null);
  const stepTwoFormRef = useRef(null);
  const stepThreeFormRef = useRef(null);
  const stepFourFormRef = useRef(null);
  const stepFiveFormRef = useRef(null);
  const [autocomplete, setAutocomplete] = useState(null);

  const totalSteps = 4;
  // Effects
  useEffect(() => {
    setSelectedProject(showType);
  }, [showType]);

  // Effect to reset all data when the main modal is closed
  useEffect(() => {
    if (!show && !personalInfo && !bathroom && !kitchen && !other && !confirmation2 && !confirmation && !photoUpload && !photoUpload2 && !photoUpload3) {
      resetAllData();
    }
  }, [show ,personalInfo ,bathroom ,kitchen ,other ,confirmation2 ,confirmation ,photoUpload ,photoUpload2,photoUpload3]);

  // useEffect(() => {
  //   if (personalInfo) {
  //     resetFormData();
  //   }
  // }, [personalInfo]);

  useEffect(() => {
    validateCurrentStep();
  }, [name, email, contact, address, step, description]);

  // Complete reset of all data and states
  const resetAllData = () => {
    resetFormData();
    setSelectedProject(null);
    setStep(1);
    setValidated(false);
    setIsNextDisabled(true);
    setErrorMessage("");
    setErrorMessageKitchen("");
    setFormDataResponse("");
    setFormDataImg(undefined);
  };

  // Form validation
  const validateCurrentStep = () => {
    switch (step) {
      case 1:
        setIsNextDisabled(name.trim() === "");
        break;
      case 2:
        setIsNextDisabled(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
        break;
      case 3:
        setIsNextDisabled(address.trim() === "");
        break;
      case 4:
        setIsNextDisabled(!/^\d{10,15}$/.test(contact));
        break;
      case 5:
        setIsNextDisabled(description.trim() === "");
        break;
      default:
        setIsNextDisabled(true);
    }
    setValidated(false);
  };

  // Reset form data
  const resetFormData = () => {
    setName("");
    setDescription("");
    setEmail("");
    setAddress("");
    setContact("");
    setValidated(false);
    setErrorMessage("");
  };

  // Handle project card selection
  const handleCardClick = (id) => {
    setSelectedProject(id);
  };

  // Handle place selection from Google Autocomplete (U.S. only)
  const handlePlaceSelect = () => {
    if (!autocomplete) return;
    const place = autocomplete.getPlace();
    if (place?.formatted_address) {
      if (!googlePlaceIsUnitedStates(place)) {
        setErrorMessage("Please select a U.S. address.");
        return;
      }
      setErrorMessage("");
      setAddress(place.formatted_address);
    }
  };

  // Modal toggles with reset functionality
  const togglePersonalInfo = () => {
    if (personalInfo) {
      resetFormData();
    }
    setPersonalInfo(!personalInfo);
    if (!personalInfo) {
      setStep(1);
    }
  };

  const toggleBathroom = () => {
    setPersonalInfo(false)
    setBathroom(!bathroom);
    if (bathroom) {
      setSelectedProject("");
    }
  };

  const toggleKitchen = () => {
    setPersonalInfo(false)
    setKitchen(!kitchen);
    if (kitchen) {
      setSelectedProject("");
    }
  };

  const toggleOther = () => {
    setPersonalInfo(false)
    setOther(!other);
    if (other && showModal) {
      // Handle special case for showModal
    }
  };

  const toggleConfirmation = () => {
    setConfirmation(!confirmation);
    if (confirmation) {
      // Reset confirmation specific data if needed
    }
  };

  const toggleConfirmation2 = () => {
    setConfirmation2(!confirmation2);
    if (confirmation2) {
      // Reset confirmation2 specific data if needed
    }
  };

  const togglePhotoUpload = () => {
    setPhotoUpload(!photoUpload);
    if (photoUpload) {
      // Reset photo upload specific data if needed
    }
  };

  const togglePhotoUpload2 = () => {
    setPhotoUpload2(!photoUpload2);
    if (photoUpload2) {
      // Reset photo upload2 specific data if needed
    }
  };

  const togglePhotoUpload3 = ()=>{
    setPhotoUpload3(!photoUpload3);
    if (photoUpload3) {
      // Reset photo upload2 specific data if needed
    }
  }

  const toggleThankyou = () => {
    setThankyou(!thankyou);
    if (thankyou) {
      resetAllData();
    }
  };

  // Navigation handlers
  const handleCloseInitialModal = () => {
    handleClose();
    resetAllData();
  };

  const handleNext = (e) => {
    validateStepForm(e);
    if (step < totalSteps) {
      setStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setIsNextDisabled(false);
      setStep((prevStep) => prevStep - 1);
    }
  };

  const handleInitialNext = () => {
    setErrorMessageKitchen("");
    if (selectedProject === "" || selectedProject === null) {
      setErrorMessageKitchen("Please select project type");
      return;
    }
    handleClose();
    setPersonalInfo(true);
    setStep(1);
  };

  // Form validation for each step
  const validateStepForm = (e) => {
    let form;
    switch (step) {
      case 1:
        form = stepOneFormRef.current;
        if (form && form.checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();
          setValidated(true);
          setIsNextDisabled(true);
          setErrorMessage("Please provide your full name.");
          return;
        }
        setErrorMessage("");
        break;
      case 2:
        form = stepTwoFormRef.current;
        if (form && form.checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();
          setValidated(true);
          setIsNextDisabled(true);
          setErrorMessage("Please provide your valid email.");
          return;
        }
        setErrorMessage("");
        break;
      case 3:
        form = stepThreeFormRef.current;
        if (form && form.checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();
          setValidated(true);
          setIsNextDisabled(true);
          setErrorMessage("Please provide your valid address.");
          return;
        }
        setErrorMessage("");
        break;
      case 4:
        form = stepFourFormRef.current;
        if (form && form.checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();
          setValidated(true);
          setIsNextDisabled(true);
          setErrorMessage("Please provide your mobile number.");
          return;
        }
        setErrorMessage("");
        break;
      case 5:
        form = stepFiveFormRef.current;
        if (form && form.checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();
          setValidated(true);
          setIsNextDisabled(true);
          setErrorMessage("Please provide Project Description.");
          return;
        }
        setErrorMessage("");
        break;
      default:
        break;
    }
    setValidated(!validated);
  };

  // Submit handlers based on project type
  const handleSubmitNext = (e) => {
    if (selectedProject === "Bathroom") {
      if (step === 4) {
        const form = stepFourFormRef.current;
        if (form && form.checkValidity() === false) {
          e.preventDefault();
          e.stopPropagation();
          setValidated(true);
          setErrorMessage("Please provide your mobile number.");
          return;
        }
        setErrorMessage("");
      }
      toggleBathroom();
    } else if (selectedProject === "Kitchen") {
      toggleKitchen();
    } else if (selectedProject === "Other" || selectedProject === "Consultation") {
      toggleOther();
    } else {
      alert("Please select a project type before proceeding.");
    }
  };

  // Confirmation handlers
  const handleConfirmationNext = (responses, fileUploads,description) => {
    setFormDataResponse(responses);
    setDescription(description)
    setFormDataImg(fileUploads);
    setBathroom(false);
    setConfirmation(true);
  };

  const handleConfirmationNext2 = (responses, file,description) => {
    setFormDataResponse(responses);
    setDescription(description)
    setFormDataImg(file);
    setKitchen(false);
    setConfirmation2(true);
  };

  const handleConfirmationNext3 = (responses, file,description) => {
    setFormDataResponse(responses);
    setDescription(description)
    setFormDataImg(file);
    setOther(false);
    setPhotoUpload3(true);
  };
  const handleNextModal = () => {
    setConfirmation(false);
    setPhotoUpload(true);
  };

  const handleNextModal2 = () => {
    setConfirmation2(false);
    setPhotoUpload2(true);
  };

  // Final submission handlers
  const handleBathroomThankyou = async (img, bathroomDataResponseData, bathroomDataImgData, multipleImages) => {
    try {
      setLoadBtn(true);

      const uploadedImages = await uploadFilesBySlots([
        bathroomDataImgData?.[0]?.[0] ?? null,
        img["bathroom1"] ?? null,
        img["bathroom2"] ?? null,
        img["bathroom3"] ?? null,
        img["bathroom4"] ?? null,
        ...multipleImages.map((image) => image.file),
      ]);

      const formData = new FormData();
      formData.append("type", "Bathroom");
      formData.append("fullName", name);
      formData.append("email", email);
      formData.append("description", description);
      formData.append("fulladdress", address);
      formData.append("contactno", contact);
      formData.append("master", bathroomDataResponseData[1]);
      formData.append("architecturalplansordrawings", bathroomDataResponseData[2]);
      formData.append("buildingpermit", bathroomDataResponseData[3]);
      formData.append("workingwithdesigner", bathroomDataResponseData[4]);
      formData.append("sellinghome", bathroomDataResponseData[5]);

      formData.append("architecturalPic", uploadedImages[0]);
      formData.append("bathroom1", uploadedImages[1]);
      formData.append("bathroom2", uploadedImages[2]);
      formData.append("bathroom3", uploadedImages[3]);
      formData.append("bathroom4", uploadedImages[4]);
      appendOtherImages(formData, uploadedImages.slice(5));

      await axios.post(`${API_URL}/v1/api/submitForm`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      setLoadBtn(false);
      setPhotoUpload(false);
      setThankyou(true);
      setFormDataImg(null);
    } catch (error) {
      setLoadBtn(false);
      console.error("Error uploading files:", error);
      setErrorMessage("Upload failed. Please try again.");
    }
  };

  const handleKitchenThankyou = async (img, kitchenDataResponseData, kitchenDataImgData, multipleImages) => {
    try {
      setLoadBtn(true);
      
      const uploadedImages = await uploadFilesBySlots([
        kitchenDataImgData ?? null,
        img["kitchen1"] ?? null,
        img["kitchen2"] ?? null,
        img["kitchen3"] ?? null,
        img["kitchen4"] ?? null,
        ...multipleImages.map((image) => image.file),
      ]);

      const formData = new FormData();
      formData.append("type", "Kitchen");
      formData.append("fullName", name);
      formData.append("email", email);
      formData.append("fulladdress", address);
      formData.append("contactno", contact);
      formData.append("description", description);
      formData.append("master", kitchenDataResponseData[1]);
      formData.append("architecturalplansordrawings", kitchenDataResponseData[1]);
      formData.append("buildingpermit", kitchenDataResponseData[2]);
      formData.append("workingwithdesigner", kitchenDataResponseData[3]);
      formData.append("sellinghome", kitchenDataResponseData[4]);

      formData.append("architecturalPic", uploadedImages[0]);
      formData.append("kitchen1", uploadedImages[1]);
      formData.append("kitchen2", uploadedImages[2]);
      formData.append("kitchen3", uploadedImages[3]);
      formData.append("kitchen4", uploadedImages[4]);
      appendOtherImages(formData, uploadedImages.slice(5));
      
      await axios.post(`${API_URL}/v1/api/submitForm`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      setLoadBtn(false);
      setPhotoUpload2(false);
      setThankyou(true);
    } catch (error) {
      setLoadBtn(false);
      console.error("Error uploading files:", error);
      setErrorMessage("Upload failed. Please try again.");
    }
  };

  const handleOtherThankyou = async (responses, file, multipleImages) => {
    try {
      setLoadBtn(true);      
      const uploadedImages = await uploadFilesBySlots([
        file ?? null,
        ...multipleImages.map((image) => image.file),
      ]);

      const formData = new FormData();
      formData.append("type", "Other");
      formData.append("fullName", name);
      formData.append("email", email);
      formData.append("fulladdress", address);
      formData.append("description", description);
      formData.append("contactno", contact);
      formData.append("architecturalplansordrawings", responses[1]);
      formData.append("buildingpermit", responses[2]);
      formData.append("workingwithdesigner", responses[3]);
      formData.append("sellinghome", responses[4]);
      formData.append("architecturalPic", uploadedImages[0]);
      appendOtherImages(formData, uploadedImages.slice(1));
      await axios.post(`${API_URL}/v1/api/submitForm`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      setLoadBtn(false);
      setPhotoUpload3(false);
      setThankyou(true);
    } catch (error) {
      setLoadBtn(false);
      console.error("Error uploading files:", error);
      setErrorMessage("Upload failed. Please try again.");
    }
  };

  // Render Personal Info Step
  const renderPersonalInfoStep = () => {
    switch (step) {
      case 1:
        return (
          <div className="personalInfosteps">
            <h4>Tell Us About Yourself</h4>
            <Image className="personalIcon" src={idcard} alt="" />
            <Form onSubmit={(e) => e.preventDefault()} noValidate validated={validated} ref={stepOneFormRef} className="text-start">
              <Form.Group className="form-group">
                <Form.Label>
                  Full Name<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control required type="text" value={name} onChange={(e) => setName(e.target.value)} />
              </Form.Group>
              {errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
            </Form>
          </div>
        );
      case 2:
        return (
          <div className="personalInfosteps">
            <h4>Tell Us About Yourself</h4>
            <Image className="personalIcon" src={emailicon} alt="" />
            <Form onSubmit={(e) => e.preventDefault()} noValidate ref={stepTwoFormRef} className="text-start">
              <Form.Group className="form-group">
                <Form.Label>
                  Email<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control required type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
              </Form.Group>
              {errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
            </Form>
          </div>
        );
      case 3:
        return (
          <div className="personalInfosteps">
            <h4>Tell Us About Yourself</h4>
            <Image className="personalIcon" src={mapIcon} alt="" />
            <Form onSubmit={(e) => e.preventDefault()} noValidate ref={stepThreeFormRef} className="text-start">
              <Form.Group className="form-group">
                <Form.Label>
                  Full Address<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Autocomplete
                  options={GOOGLE_PLACES_AUTOCOMPLETE_OPTIONS}
                  onLoad={(auto) => setAutocomplete(auto)}
                  onPlaceChanged={handlePlaceSelect}
                >
                  <div className="position-relative">
                    <Form.Control
                      required
                      className="pe-5"
                      type="text"
                      value={address}
                      placeholder="Search address"
                      onChange={(e) => setAddress(e.target.value)}
                    />
                    <Icon className="iconright" icon="typcn:location" width={24} height={24} />
                  </div>
                </Autocomplete>
              </Form.Group>
              {errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
            </Form>
          </div>
        );
      case 4:
        return (
          <div className="personalInfosteps">
            <h4>Tell Us About Yourself</h4>
            <Image className="personalIcon" src={callIcon} alt="" />
            <Form onSubmit={(e) => e.preventDefault()} noValidate ref={stepFourFormRef} className="text-start">
              <Form.Group className="form-group">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={contact}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,15}$/.test(input)) {
                      setContact(input);
                    }
                  }}
                  placeholder="Enter Contact Number"
                />
              </Form.Group>
              {errorMessage && <div className="text-danger">{errorMessage}</div>}
            </Form>
          </div>
        );
      case 5:
        return (
          <div className="personalInfosteps">
            <h4>Tell Us About Project</h4>
            <Image className="personalIcon" src={Description} alt="" />
            <Form onSubmit={(e) => e.preventDefault()} noValidate ref={stepFiveFormRef} className="text-start">
              <Form.Group className="form-group">
                <Form.Label>Project Description</Form.Label>
                <Form.Control
                  required
                  as="textarea"
                  name="projectDescription"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={4}
                  style={{ height: "auto" }}
                />
              </Form.Group>
              {errorMessage && <div className="text-danger">{errorMessage}</div>}
            </Form>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {/* Project Type Selection Modal */}
      <Modal 
        show={show} 
        onHide={handleCloseInitialModal}
        onExited={cleanupModalScrollLock}
        enforceFocus={false}
        restoreFocus={false}
        centered 
        size="lg" 
        className="modal-getstarted"
        // onExited={resetAllData} // Reset all data when modal completely exits
      >
        <button
          type="button"
          className="rs-lc-close"
          onClick={handleCloseInitialModal}
          aria-label="Close"
        >
          <Icon icon="tabler:x" width={22} height={22} />
        </button>
        <Modal.Body className="rs-lc-body">
          <div className="rs-lc-inner rs-lc-inner--wide">
            <div className="rs-lc-step">
              <p className="rs-lc-kicker">Rapid estimate</p>
              <h2 className="rs-lc-title">Select project type</h2>
              <p className="rs-lc-lead">
                Choose the space you&apos;re planning to transform — we&apos;ll tailor the next steps for you.
              </p>
              {errorMessageKitchen && (
                <div className="text-danger mb-3" style={{ fontSize: "0.9rem" }}>
                  {errorMessageKitchen}
                </div>
              )}
              <div className="rs-lc-options-grid" role="group" aria-label="Project types">
                {PROJECT_TYPES.map((project) => (
                  <button
                    key={project.id}
                    type="button"
                    className={`rs-re-project-card${
                      selectedProject === project.name ? " rs-re-project-card--selected" : ""
                    }`}
                    onClick={() => handleCardClick(project.name)}
                  >
                    <span className="rs-re-project-card__media">
                      <Image
                        src={project.img}
                        alt=""
                        className="rs-re-project-card__img img-fluid"
                      />
                      <Image className="rs-re-project-card__icon" src={project.icon} alt="" />
                    </span>
                    <span className="rs-lc-option-label">{project.name}</span>
                  </button>
                ))}
              </div>
              <div className="rs-lc-actions">
                <button
                  type="button"
                  className="rs-lc-submit"
                  onClick={handleInitialNext}
                  disabled={!selectedProject}
                >
                  Next <span aria-hidden>→</span>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Personal Info Modal */}
      <Modal 
        show={personalInfo} 
        onHide={togglePersonalInfo} 
        centered 
        className="modal-getstarted modalnext " 
        // onExited={() => resetFormData()} // Reset form data when modal completely exits
      >
        <button
          type="button"
          className="rs-lc-close"
          onClick={togglePersonalInfo}
          aria-label="Close"
        >
          <Icon icon="tabler:x" width={22} height={22} />
        </button>
        <Modal.Body className="text-center rs-lc-body">
          {/* Progress Bar */}
          <div className="peronalInfoProgress mb-4">
            {[...Array(totalSteps)].map((_, index) => (
              <span key={index} className={index < step ? "done" : ""}></span>
            ))}
          </div>

          {/* Steps Content */}
          {renderPersonalInfoStep()}

          {/* Navigation Buttons */}
          <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mt-3">
            {step > 1 && step < totalSteps && (
              <Button variant="outline-primary" onClick={handleBack} style={{ minWidth: 180 }}>
                Back
              </Button>
            )}
            {step < totalSteps ? (
              <Button onClick={handleNext} style={{ minWidth: 180 }} disabled={isNextDisabled}>
                Next <span aria-hidden>→</span>
              </Button>
            ) : (
              <Button style={{ minWidth: 180 }} onClick={handleSubmitNext} disabled={isNextDisabled}>
                Submit <span aria-hidden>→</span>
              </Button>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* Project Type Modals */}

      {(bathroom || kitchen || other || confirmation2 || confirmation || photoUpload || photoUpload2 || photoUpload3)
      
      ?
      <>
        <BathroomModal
        Bathroom={bathroom}
        BathroomToggle={toggleBathroom}
        StepcompleteNext={handleConfirmationNext}
      />
      
      <KitchenModal
        Kitchen={kitchen}
        KitchenToggle={toggleKitchen}
        StepcompleteNext={handleConfirmationNext2}
      />
      
      <OtherModal
        Other={other}
        OtherToggle={toggleOther}
        stepCompleteNext={handleConfirmationNext3}
        loadBtn={loadBtn}
        selectedProject={selectedProject}
      />

      {/* Confirmation Modals */}
      <ConfirmationModal
        Confirmation={confirmation}
        ConfirmationToggle={toggleConfirmation}
        NextModal={handleNextModal}
      />
      
      <ConfirmationModal2
        Confirmation={confirmation2}
        ConfirmationToggle={toggleConfirmation2}
        NextModal={handleNextModal2}
      />

      {/* Photo Upload Modals */}
      <PhotoUploadModal
        PhotoUpload={photoUpload}
        PhotoUploadToggle={togglePhotoUpload}
        ThankyouOpen={handleBathroomThankyou}
        loadBtn={loadBtn}
        BathroomDataResponse={formDataResponse}
        BathroomDataImg={formDataImg}
      />
      
      <PhotoUploadModal2
        PhotoUpload={photoUpload2}
        PhotoUploadToggle={togglePhotoUpload2}
        ThankyouOpen={handleKitchenThankyou}
        loadBtn={loadBtn}
        BathroomDataResponse={formDataResponse}
        BathroomDataImg={formDataImg}
      />
      <PhotoUploadModal3
          PhotoUpload={photoUpload3}
          PhotoUploadToggle={togglePhotoUpload3}
          ThankyouOpen={handleOtherThankyou}
          loadBtn={loadBtn}
          OtherDataResponse={formDataResponse}
          OtherDataImg={formDataImg}
      />
      </> :
       ""}
      

      {/* Thank You Modal */}
      <ThankyouModal 
        Thankyou={thankyou} 
        ThankyouToggle={toggleThankyou} 
      />

      {/* Let's Connect is handled by LandingLayout on marketing pages */}
      {typeof setCloseShowModal === "function" ? (
        <LetsConnect letsconnect={showModal} onClose={setCloseShowModal} />
      ) : null}
      <PhotoLightboxHost />
    </>
  );
};

export default GetStarted;